import React, {CSSProperties, ReactNode} from 'react'

import {modalStyle} from './styles.js'

interface ModalActionsProps {
    children?: ReactNode
    /** At the left, the buttons stay at the right (e.g. the number of selected items); nothing when falsy */
    start?: ReactNode
    style?: CSSProperties
}

/** The button row at the bottom of a Modal: right-aligned, with the column gap between the buttons */
export default function ModalActions({children, start, style}: ModalActionsProps) {
    return (
        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', columnGap: modalStyle.actionsGap, ...style}}>
            {!!start &&
                <div style={{display: 'flex', alignItems: 'center', flex: 1}}>
                    {start}
                </div>
            }

            {children}
        </div>
    )
}
